/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/05/27 16:53:47
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
import { loadMonaco, loadBeautifier, beautifierConf } from "@newview/form-generator";

@Component({
    components: {

    }
})
export default class MonacoEditor extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    @Prop({ default: "json" })
    language?: string;

    jsonEditorId: string = this.getUniqueCode();
    monaco;
    jsonEditor;
    isInit: boolean = false;

    jsonContent: any = {};
    beautifier;

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        
    }

    //#endregion 事件定义区

    //#region 方法定义区

    init() {
        loadMonaco(val => {
            this.isInit = true;
            this.monaco = val;
            this.setEditorValue(this.jsonEditorId, this.jsonContent);
        })
    }

    setEditorValue(id, codeStr) {
        if (this.jsonEditor) {
            this.jsonEditor.setValue(codeStr)
        } else {
            this.jsonEditor = this.monaco.editor.create(document.getElementById(id), {
                value: codeStr,
                theme: 'vs-dark',
                language: this.language!,
                automaticLayout: true
            })
            // ctrl + s 保存
            this.jsonEditor.onKeyDown(e => {
                if (e.keyCode === 49 && (e.metaKey || e.ctrlKey)) {
                    e.preventDefault();
                    this.$emit('save', this.jsonEditor.getValue());
                } else if (e.keyCode === 34 && (e.metaKey || e.ctrlKey)) {
                    e.preventDefault();
                    this.$emit('close');
                }
            })
        }
    }

    setData(jsonContent) {
        loadBeautifier((btf) => {
            this.beautifier = btf;
            this.jsonContent = this.beautifier.js(jsonContent, beautifierConf.js);

            if (!this.isInit) {
                this.init();
                return;
            }
            this.setEditorValue(this.jsonEditorId, this.jsonContent);
        });
    }

    getData() {
        return this.jsonEditor.getValue()
    }

    //#endregion 方法定义区
}